export default "__VITE_ASSET__CJAMbFUM__"